import React, { useEffect, useRef, useState } from 'react';
import {
  Col,
  Row,
  Tabs,
  Tab,
  Card,
  Form,
  Button,
  Table,
} from 'react-bootstrap';
import moment from 'moment';

import Layout from '../../wrappers/layout';
import { useHistory, useLocation } from 'react-router-dom';
import CurrencyInput from 'react-currency-input-field';
import './styles.css';
import Faq from './faq';
import { toast } from 'react-toastify';
import SipHttp from './sip.service';
import { userStore } from 'store/UserStore';
import BuySellService from '../../services/buy-sell.service';
import Alert from 'shared/common/alert';
import EmandateList from './EmandateList';
import dashboardService from 'services/dashboard.service';
import KycPopup from 'shared/common/kycPopup';

interface PropsType { }


const SIP_AMOUNT_CONFIG: any = {
  daily: {
    min: 10,
    default: 51,
  },
  weekly: {
    min: 100,
    default: 1000,
  },
  monthly: {
    min: 100,
    default: 5000,
  },
};

const SIP_DEFAULT_METAL: any = {
  daily: {
    metalType: 'Au',
    itemCode: 'Au00005',
  },
  weekly: {
    metalType: 'Ag',
    itemCode: 'Ag0003',
  },
  monthly: {
    metalType: 'Ag',
    itemCode: 'Ag0003',
  },
};



const SipPage: React.FC<PropsType> = () => {
  const history = useHistory();
  const location = useLocation();
  const sipDashData = location.state || "";
  const [selectedTab, setSelectedTab] = useState<any>('createnewsip');
  const [amountValue, setAmountValue] = useState<any | null>(null);
  const [gramValue, setGramValue] = useState<any | null>(null);
  const [planTime, setPlanTime] = useState('');
  const [metalType, setMetalType] = useState('');
  const [sipButtonFlag, setSipButtonFlag] = useState(true);
  const [SIPList, setSIPList] = useState([]);
  const [isKYCRequired, setIsKYCRequired] = useState(false);
  const [investType, setInvestType] = useState('amount');
  const [customerId, setUser] = userStore((state: any) => [
    state.customerId,
    state.setUser,
  ]);
  const [filter, setFilter] = useState({
    customerId: customerId,
    metal: '',
    frequency: '',
    start_date: '',
    end_date: '',
  });

  //pricebrkdown
  const targetSell = useRef(null);
  const [isPriceBreakdownShowSell, setIsPriceBreakdownShowSell] =
    useState(false);
  const [loading, setLoading] = useState<any>(false);
  const [itemCode, setItemCode] = useState<any>('');
  const [user, selectedAccount, customer] = userStore((state: any) => [
    state.user,
    state.selectedAccount,
    state.customer,
  ]);
  const [open, setOpen] = useState<any>(false);
  const [statusId, setStatusId] = useState<any>('');

  const handleToggle = async (sipid) => {
    try {
      const data = { sip_id: sipid, status: 'INACTIVE', user_id: user?.userId };
      const res = await SipHttp.changeSIPStatus(data);
      if (res?.status == 200) {
        toast.success('SIP deactivated successfully!');
        getSIPList();
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const addquoute = async () => {
    const quotedata = {
      currency: 'INR',
      ebActRef: selectedAccount?.accountId,
      items: [
        {
          itemCode: itemCode,
          otherItems: [],
          requestedType: 'PRODUCT_QTY',
          requestedValue: Number(gramValue),
          requestedValueAmount: null,
          requestedValueQuantity: gramValue,
          uom: 'g',
        },
      ],

      type: 'SELL',
    };
    const resp = await BuySellService.addQuote(quotedata, user?.userId, '');
    if (resp.data.data?.summary?.quotationTotal > 100000) {
      toast.error('Investment cannot exceed ₹1,00,000 ');
      setSipButtonFlag(true);
    } else {
      setSipButtonFlag(false);
    }
  };
  //---end
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };

  const onAmountClick = (value) => {
    setAmountValue(amountValue + value);
  };
  const onGramClick = (value) => {
    setGramValue(Number(gramValue) + Number(value));
  };

  const onSipClick = () => {
    history.push({
      pathname: '/sip-plan',
      state: {
        sipMetalType: metalType,
        sipAmount: amountValue,
        sipGram: gramValue,
        sipInterval: planTime,
      },
    });
  };

  const getSIPList = async () => {
    try {
      const resp = await SipHttp.getSIPList(filter, user?.userId);
      if (resp.status == 200) {
        setSIPList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeFilter = async (e: any) => {
    const { name, value } = e.target;

    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const onKycModalClose = () => {
    setIsKYCRequired(false);
  };


  const setSIPInitialState = async () => {
    setFilter((prevState) => {
      return {
        ...prevState,
        frequency: '',
        customerId: customerId,
        metal: '',
        start_date: '',
        end_date: '',
      };
    });
  };

  const onSuccess = () => {
    // cancelFunction();
    handleToggle(statusId);
    setOpen(false);
  };

  const onCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    getSIPList();
  }, [filter]);

  useEffect(() => {
    if (planTime && investType === 'amount') {
      const config = SIP_AMOUNT_CONFIG[planTime];

      if (config) {
        setAmountValue(config.default);
      }
    }
  }, [planTime, investType]);


  //@ts-ignore
  useEffect(() => {
    if (!metalType || !planTime) {
      setSipButtonFlag(true);
      return;
    }

    if (investType === 'amount') {
      const minAmount = SIP_AMOUNT_CONFIG[planTime]?.min || 0;

      if (!amountValue || amountValue < minAmount) {
        setSipButtonFlag(true);
        return;
      }

      if (amountValue > 100000) {
        toast.error('Amount should be less than ₹1,00,000');
        setSipButtonFlag(true);
        return;
      }
    }

    setSipButtonFlag(false);
  }, [metalType, planTime, amountValue, gramValue, investType]);


  const handleViewClick = async (sip) => {
    try {
      const res: any = await dashboardService.getAllMetals();

      if (res.status === 200 && res.data.data) {
        const response = res?.data?.data?.result;

        const metalMatch = await response?.find(
          (m) => sip?.metal == m?.metalCode
        );

        if (metalMatch) {
          sip['itemCode'] = metalMatch?.itemCode;
          const encodedSip = encodeURIComponent(JSON.stringify(sip));
          history.push(`/sip-payment-schedule/${sip.id}?data=${encodedSip}`);
        } else {
          toast.error('Something went wrong');
        }
        return Promise.resolve(true);
      } else {
        return Promise.reject(false);
      }
    } catch (e: any) {
      console.log(e.message);
      return Promise.reject(false);
    }
  };


  const getDefaultFrequencyFromRoute = (pathname: string) => {
  if (pathname.includes('/daily-savings')) return 'daily';
  return 'monthly';
};



  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const selectedTabFromQuery = queryParams.get('tab');
    const toastMessage = queryParams.get('toastMessage');
    // Check if the selectedTabFromQuery is 'sippassbook'
    if (selectedTabFromQuery === 'sippassbook') {
      setSelectedTab('sippassbook');
      // Store the selected tab in browser storage
    }
    if (toastMessage) {
      toast.success(decodeURIComponent(toastMessage));
      const newSearch = queryParams.toString().replace('toastMessage', '');
      history.replace({
        search: newSearch,
      });
    }
  }, [history]);

  const checkPanRequirement = async () => {
    try {
      if (!customer?.kyc?.pan?.isVerified) {
        return setIsKYCRequired(true);
      } else {
        onSipClick();
      }
    } catch (err) {
      console.log(err);
    }
  };



  useEffect(() => {
  const defaultFrequency = getDefaultFrequencyFromRoute(location.pathname);

  const seoSip = JSON.parse(localStorage.getItem('sipdata'));
  if (seoSip) {
    setAmountValue(seoSip?.sipAmount);
    setMetalType(seoSip?.sipMetalType);
    setPlanTime(seoSip?.sipInterval || defaultFrequency);
    setItemCode(seoSip?.sipItemCode);
    localStorage.removeItem('sipdata');
    return;
  }

  if (sipDashData) {
    setAmountValue(sipDashData?.sipAmount);
    setMetalType(sipDashData?.sipMetalType);
    setPlanTime(sipDashData?.sipInterval || defaultFrequency);
    setItemCode(sipDashData?.sipItemCode);
    return;
  }

  // fallback: route-based default
  setPlanTime(defaultFrequency);
}, []);



  useEffect(() => {
  if (!planTime) return;

  // do not override if metal already chosen (or restored)
  if (metalType) return;

  const config = SIP_DEFAULT_METAL[planTime];
  if (config) {
    setMetalType(config.metalType);
    setItemCode(config.itemCode);
  }
}, [planTime]);


  return (
    <Layout>
      <div className='pb'>
        <Row>
          <Col md={12}>
            <Tabs
              defaultActiveKey={'createnewsip'}
              activeKey={selectedTab}
              id='uncontrolled-tab-example'
              className='mb-3'
              onSelect={setSelectedTab}
            >
              <Tab eventKey='createnewsip' title='Create New SIP'>
                <div style={{ backgroundColor: 'white' }}>
                  <div className='div-container'>
                    <h2>Create your SIP</h2>
                    <Card className='card-com'>
                      <Card.Body>

                        <div className='main-container'>
                          <div>
                            <h6>Frequency</h6>

                            <Form className='radio-div'>
                              <Form.Check
                                type='radio'
                                label='Daily'
                                name='payment-group'
                                value={'daily'}
                                onChange={(e) => setPlanTime(e.target.value)}
                                checked={planTime === 'daily'}
                              ></Form.Check>
                              <Form.Check
                                type='radio'
                                label='Weekly'
                                name='payment-group'
                                value={'weekly'}
                                onChange={(e) => setPlanTime(e.target.value)}
                                checked={planTime === 'weekly'}
                              ></Form.Check>
                              <Form.Check
                                type='radio'
                                label='Monthly'
                                name='payment-group'
                                value={'monthly'}
                                onChange={(e) => setPlanTime(e.target.value)}
                                checked={planTime === 'monthly'}
                              ></Form.Check>
                            </Form>
                          </div>

                          <h6>Precious Metal Type</h6>
                          <div className='radio-div'>
                            <Form.Check
                              type='radio'
                              label='Silver'
                              name='payment-group'
                              value={'Ag'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              id='Ag0003'
                              checked={metalType === 'Ag'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Gold'
                              value={'Au'}
                              id={'Au00005'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Au'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Platinum'
                              value={'Pt'}
                              id={'Pt00003'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Pt'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Palladium'
                              value={'Pd'}
                              id={'Pd00008'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Pd'}
                            ></Form.Check>
                          </div>
                          <div className='sub-container'>
                            <div className='sub1-container'>


                              <div
                                className='d-flex tg-btns'

                              >

                              </div>
                              <div className='d-flex justify-content-between'>
                                <h6>{`Enter investment ${investType}`}</h6>

                              </div>
                              {investType == 'amount' ? (
                                <>
                                  <CurrencyInput

                                    className='text-end form-control'
                                    name='amount'
                                    allowNegativeValue={false}
                                    // value={razorpay.amount}
                                    onWheel={(e: any) => e.target.blur()}
                                    onValueChange={
                                      (value, name) => {
                                        Number(value) > 0
                                          ? setAmountValue(Number(value))
                                          : setAmountValue(Number(null));
                                      }
                                      // onChangeAmount(value, name, true)
                                    }
                                    value={amountValue}
                                    prefix='₹ '
                                    placeholder='₹ 0'
                                    maxLength={6}
                                  />

                                  <span>
                                    Minimum SIP amount is ₹ {SIP_AMOUNT_CONFIG[planTime]?.min || 0}
                                  </span>

                                </>
                              ) : (
                                <>
                                  <CurrencyInput

                                    className='text-end form-control'
                                    name='gram'
                                    allowNegativeValue={false}
                                    // value={razorpay.amount}
                                    onWheel={(e: any) => e.target.blur()}
                                    onValueChange={
                                      (value, name) => {
                                        Number(value) > 0
                                          ? setGramValue(value)
                                          : setGramValue(Number(null));
                                      }
                                      // onChangeAmount(value, name, true)
                                    }
                                    value={gramValue}
                                    suffix=' g'
                                    decimalsLimit={4}
                                    decimalScale={4}
                                    placeholder='0.0000 g'
                                  />

                                  <span>Minimum SIP investment is 1g.</span>
                                </>
                              )}
                            </div>
                            <div className='sub2-container'>
                              <Button
                                // variant='outline-warning'
                                size='sm'
                                disabled={sipButtonFlag}
                                onClick={() => checkPanRequirement()}
                                className='Start-An-AIP'
                              >
                                Start SIP
                              </Button>
                            </div>
                          </div>
                          <div className='sub3-container'>
                            {investType == 'amount' ? (
                              <div className='d-flex justify-content-around mb-3 mt-3 tg-btns'>
                                {[100, 500, 1000, 10000].map((amount) => (
                                  <Button
                                    variant='outline-warning'
                                    size='sm'
                                    onClick={(e) => {
                                      onAmountClick(Number(amount));
                                    }}
                                    className='currency'
                                  >
                                    + ₹{amount}
                                  </Button>
                                ))}
                              </div>
                            ) : (
                              <div className='d-flex justify-content-around mb-3 mt-3 tg-btns'>
                                {[1.0, 5.0, 10.0, 25.0].map((gram) => (
                                  <Button
                                    variant='outline-warning'
                                    size='sm'
                                    onClick={(e) => {
                                      onGramClick(Number(gram));
                                    }}
                                    className='currency'
                                  >
                                    + {gram} g
                                  </Button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* </Tab>  */}
                      </Card.Body>
                    </Card>
                  </div>

                  <div className='faq-container'>
                    <h2 className='faq-heading'>Frequently Asked Questions</h2>
                    <Faq />
                  </div>
                </div>
              </Tab>
              <Tab eventKey='sippassbook' title='SIP Passbook'>
                <div>
                  <Card>
                    <Card.Body>
                      <Row className='align-items-center'>
                        <Col md={3}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>SIP Type</Form.Label>
                            <Form.Select
                              aria-label='Default select example'
                              name='frequency'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.frequency}
                            >
                              <option value=''>Frequency</option>
                              <option value='weekly'>Weekly</option>
                              <option value='monthly'>Monthly</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group className='mb-3' controlId='orderMetal'>
                            <Form.Label>Order Metal</Form.Label>
                            <Form.Select
                              aria-label='Default select example'
                              name='metal'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.metal}
                            >
                              <option value=''> Metals</option>
                              <option value='Ag'>Silver (Ag)</option>
                              <option value='Au'>Gold (Au)</option>
                              <option value='Pt'>Platinum (Pt)</option>
                              <option value='Pd'>Palladium (Pd)</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={2}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>Order From Date</Form.Label>
                            <Form.Control
                              type='date'
                              name='start_date'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.start_date}
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                        <Col md={2}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>Order To Date</Form.Label>
                            <Form.Control
                              type='date'
                              name='end_date'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.end_date}
                            // min={filter.fromDate}
                            // disabled={filter.fromDate === ''}
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                        <Col md={2} className='p-0 pt-2'>
                          <Button
                            onClick={() => getSIPList()}
                            className='mx-2'
                            variant='primary'
                          >
                            Apply
                          </Button>
                          <Button
                            onClick={setSIPInitialState}
                            variant='secondary'
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <div className='t-wrap overflow-auto'>
                    <Table
                      className='mb-0 w-100 txn__table'
                      striped
                      hover
                      responsive
                    >
                      <thead>
                        <tr>
                          <th>SIP</th>
                          <th>plan name</th>
                          <th>Metal</th>
                          <th>Frequency</th>
                          <th>start date</th>
                          {/* <th>End Date</th> */}
                          <th>Duration</th>
                          <th>Status</th>
                          <th>Amount</th>
                          <th>E-mandate Status</th>
                          <th>Payment Schedule</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {SIPList?.length > 0 ? (
                          SIPList?.map((sip, index) => (
                            <tr key={index}>
                              <td className=''>{sip?.id}</td>
                              <td>{sip?.planName}</td>
                              <td>
                                {/* {formatAmount(metal.items[0].itemBreakDown[0].qty, 4)}g  */}
                                {sip?.metal}
                              </td>
                              <td className=''>{sip?.frequency}</td>
                              <td>
                                {/* /<div className='badge bg-secondary'>  */}
                                <div className=''>
                                  {moment(sip?.startDate).format('DD-MMM-yyyy')}
                                </div>
                              </td>

                              <td>{sip?.duration} Months</td>
                              <td>{sip?.status}</td>
                              <td className=''>₹{sip?.installmentAmt}</td>

                              <td className=''>
                                {sip?.mandateStatus ? sip?.mandateStatus : '-'}
                              </td>
                              <td className=''>
                                <Button
                                  variant='primary'
                                  onClick={() => handleViewClick(sip)}
                                  bsPrefix='btn-table'
                                  size='sm'
                                >
                                  View
                                </Button>
                              </td>
                              <td className=''>

                                {sip?.status == 'ACTIVE' ? (
                                  <Button
                                    variant='primary'
                                    onClick={() => {
                                      setOpen(true);
                                      setStatusId(sip?.id);
                                    }}
                                    bsPrefix='btn-table'
                                    size='sm'
                                  >
                                    Deactivate
                                  </Button>
                                ) : (
                                  <div className='badge bg-secondary'>
                                    Inactive
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={11}>
                              <div className='m-2 d-flex justify-content-center'>
                                No data to display
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <Row>{/* <Col md={12}>{/ Pagination Bar /}</Col> */}</Row>
                </div>
              </Tab>
              {/* <Tab eventKey='emandateList' title='E-Mandates'>
                <div>
                  <EmandateList />
                  <Row></Row>
                </div>
              </Tab> */}
            </Tabs>
          </Col>
        </Row>
        {/* <SupportButton /> */}
        <Alert
          open={open}
          message='Are you sure you want to deactivate this SIP? Once deactivated, you cannot reactivate it.'
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
        <KycPopup
          isKYCPopupDisplayed={isKYCRequired}
          isPanVerficationRequired={true}
          closeModal={onKycModalClose}
          hideModal={onKycModalClose}
        />
      </div>
    </Layout>
  );
};

export default SipPage;
